import React from 'react';
import ReactDOM from 'react-dom';
import "./styles/index.css";
import App from "./components/App";
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from 'react-router-dom';
// import {AuthProvider} from './contexts/AuthContext'
// import 'bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter><App /></BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// @ts-ignore
reportWebVitals();
